module.exports = "/_next/static/images/Trend01Visual-d55541da02c1a42514a1d5d58a267584.png";